import type { IMedia } from "src/model/unityObject";

const REPLACEABLE_MEDIA_TYPES: readonly string[] = [
  "image",
  "video",
  "audio",
  "pdf",
  "model3d",
  "avatar",
];

export const canMediaBeReplaced = (media: IMedia, currentOrganizationId?: number): boolean =>
  REPLACEABLE_MEDIA_TYPES.includes(media.type) &&
  Number(media.id) > 0 &&
  Number(media.organization?.id) === Number(currentOrganizationId) &&
  !(media.type === "model3d" && media.media_360_tag === "media360");
